import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { COMPANY_LIST, setSelectedCompany, cacheDynamicCompanies } from "../companies";
import api from "../api";
import { ArrowRight, ShieldCheck } from "lucide-react";

const CompanySelectPage = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [dynamic, setDynamic] = useState([]);

  useEffect(() => {
    if (!loading && user) navigate("/", { replace: true });
  }, [user, loading, navigate]);

  useEffect(() => {
    api.get("/companies/public").then((r) => {
      const list = r.data?.companies || [];
      setDynamic(list);
      cacheDynamicCompanies(list);
    }).catch(() => {});
  }, []);

  const choose = (code) => {
    setSelectedCompany(code);
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#16345c] to-[#0d1b2f] text-white">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12">
        <div className="text-center mb-12 max-w-2xl">
          <span className="text-[34px] font-black">Tele<span className="text-[#ff7e00]">borsa</span> <span className="font-light text-[#ff7e00]">HR</span></span>
          <p className="text-[15px] text-gray-300 mt-6 leading-relaxed text-center">
            Piattaforma risorse umane.<br />
            Seleziona per accedere.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full max-w-3xl" data-testid="company-select-grid">
          {COMPANY_LIST.map((c) => (
            <button
              key={c.code}
              onClick={() => choose(c.code)}
              data-testid={`company-card-${c.code}`}
              className="group text-left bg-white/5 hover:bg-white/10 border border-white/15 hover:border-white/40 rounded-2xl p-7 transition-all duration-200 backdrop-blur-sm"
            >
              <span className="w-full h-[84px] rounded-xl bg-white flex items-center justify-center mb-5 px-6 shadow-sm">
                <img src={c.logo} alt={c.label} className="max-h-12 max-w-full object-contain" />
              </span>
              <div className="text-[22px] font-black mb-1" style={{ color: "#fff" }}>{c.label}</div>
              <div className="text-[13.5px] text-gray-300 mb-6">{c.tagline}</div>
              <span className="inline-flex items-center gap-2 text-[13px] font-bold" style={{ color: c.accent }}>
                Accedi <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </button>
          ))}
          {dynamic.map((c) => (
            <button
              key={c.code}
              onClick={() => choose(c.code)}
              data-testid={`company-card-${c.code}`}
              className="group text-left bg-white/5 hover:bg-white/10 border border-white/15 hover:border-white/40 rounded-2xl p-7 transition-all duration-200 backdrop-blur-sm"
            >
              <span className="w-full h-[84px] rounded-xl bg-white flex items-center justify-center mb-5 px-6 shadow-sm overflow-hidden">
                {c.has_logo
                  ? <img src={`${process.env.REACT_APP_BACKEND_URL}/api/companies/${c.code}/logo`} alt={c.label} className="max-h-14 max-w-full object-contain" />
                  : <span className="text-[30px] font-black" style={{ color: c.accent || "#0d6cb8" }}>{c.label}</span>}
              </span>
              <div className="text-[22px] font-black mb-1 text-white">{c.label}</div>
              <div className="text-[13.5px] text-gray-300 mb-6">{c.tagline || "Azienda del gruppo"}</div>
              <span className="inline-flex items-center gap-2 text-[13px] font-bold" style={{ color: c.accent || "#0d6cb8" }}>
                Accedi <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2 text-gray-400 text-[13px] mt-12">
          <ShieldCheck size={16} /> Accesso riservato e protetto
        </div>
      </div>
    </div>
  );
};

export default CompanySelectPage;
